import React from 'react';
import { Paper, Typography, Box, IconButton, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const ActivityList = ({ filteredActivities, handleOpenActivityDialog, handleActivityClick, highlightedStandIds }) => {
    return (
        <div style={{ marginTop: '20px' }}>
            <Typography variant="h6" gutterBottom>Planned Activities ({filteredActivities.length})</Typography>
            {filteredActivities.length > 0 ? (
                filteredActivities.map(a => (
                    <Paper 
                        key={a.id} 
                        elevation={2} 
                        sx={{ 
                            padding: '12px', 
                            marginBottom: '10px', 
                            cursor: 'pointer',
                            borderLeft: a.priority === 'high' ? '4px solid #f44336' : 'none',
                            backgroundColor: highlightedStandIds.includes(a.stand_id) ? '#e3f2fd' : 'white',
                            '&:hover': { backgroundColor: '#f5f5f5' }
                        }}
                        onClick={() => handleActivityClick(a)}
                    >
                        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                            <div>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    {a.activity_type} - Stand #{a.stand_number}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {a.planned_year} Q{a.planned_quarter} • {a.status}
                                </Typography>
                                {a.description && (
                                    <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                                        {a.description}
                                    </Typography>
                                )}
                            </div>
                            <IconButton 
                                size="small" 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenActivityDialog(a);
                                }}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Box>
                        <Box display="flex" gap={1} mt={1}>
                            <Chip label={a.priority} size="small" color={a.priority === 'high' ? 'error' : 'default'} />
                            <Chip label={a.performer_type} size="small" variant="outlined" />
                            {a.total_amount && (
                                <Typography variant="body2" sx={{ ml: 'auto', fontWeight: 'bold' }}>
                                    {Math.round(a.total_amount).toLocaleString()} SEK
                                </Typography>
                            )}
                        </Box>
                    </Paper>
                ))
            ) : (
                <Typography variant="body1" color="textSecondary" align="center" style={{ marginTop: '2rem' }}>
                    No activities found for current filters.
                </Typography>
            )}
        </div>
    );
};

export default ActivityList;
